<script setup lang="ts">
/**
 * LoggedOutMobileBar – mobile equivalent of LoggedOutSidebar, shown instead of
 * MobileBottomNav while no session is active.
 *
 * Deliberately not a re-skinned MobileBottomNav: with only one control to show, a
 * full-width tabbar plus a text-labelled "hide menu" handle (see MobileBottomNav) would
 * be a bar dedicated to hiding itself. Instead this is a small, always-visible pill —
 * nothing to hide, so no hide/show affordance is needed at all.
 */
import LocaleSwitcher from '@/components/sidebar/LocaleSwitcher.vue'
</script>

<template>
  <div class="logged-out-bar">
    <LocaleSwitcher />
  </div>
</template>

<style scoped>
.logged-out-bar {
  position: fixed;
  left: 50%;
  bottom: calc(16px + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 5;
  background: color-mix(in srgb, var(--color-tufte-bg) 92%, transparent);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid var(--color-tufte-border);
  border-radius: 999px;
  padding: 0.4rem 0.6rem;
  box-shadow: 0 3px 10px rgb(0 0 0 / 12%);
}
</style>
